import { applySnapshot, getSnapshot, Instance, types } from 'mobx-state-tree';
import { withSetPropAction } from './helpers/withSetPropAction';

export const CmsDialogStoreModel = types
  .model('CmsDialogStore')
  .props({
    // 弹窗是否打开
    isDialogOpen: types.optional(types.boolean, false),
    // 弹窗标题
    dialogTitle: types.optional(types.string, ''),
    // 弹窗内容
    dialogMessage: types.optional(types.string, ''),
    // 确认按钮文本
    confirmButtonText: types.optional(types.string, 'sure'),
    // 取消按钮文本
    cancelButtonText: types.optional(types.string, 'cancel'),
    // 重定向URL
    redirectUrl: types.optional(types.string, '/'),
    // 弹窗类型（用于区分不同场景的弹窗）
    dialogType: types.optional(types.string, ''),
    // 是否显示取消按钮
    showCancelButton: types.optional(types.boolean, true),
    // 自定义内容（用于更复杂的弹窗内容）
    customContent: types.optional(types.frozen({}), {}),
    // 弹窗关闭回调
    onCloseCallback: types.optional(
      types.frozen(() => {}),
      () => {},
    ),
    // 确认按钮点击回调
    onConfirmCallback: types.optional(
      types.frozen(() => {}),
      () => {},
    ),
  })
  .actions(withSetPropAction)
  .actions((self) => ({
    // 打开弹窗
    openDialog: () => {
      self.isDialogOpen = true;
    },

    // 关闭弹窗
    closeDialog: () => {
      self.isDialogOpen = false;
      // 执行关闭回调
      if (typeof self.onCloseCallback === 'function') {
        self.onCloseCallback();
      }
    },

    // 确认操作
    confirmDialog: () => {
      self.isDialogOpen = false;
      // 执行确认回调
      if (typeof self.onConfirmCallback === 'function') {
        self.onConfirmCallback();
      }
    },

    // 重置弹窗状态
    resetDialog: () => {
      self.isDialogOpen = false;
      self.dialogTitle = '';
      self.dialogMessage = '';
      self.confirmButtonText = 'sure';
      self.cancelButtonText = 'cancel';
      self.redirectUrl = '/';
      self.dialogType = '';
      self.showCancelButton = true;
      self.customContent = {};
      self.onCloseCallback = () => {};
      self.onConfirmCallback = () => {};
    },

    // 缓存到sessionStorage
    cacheToSessionStorage: () => {
      sessionStorage.setItem('dialogStore', JSON.stringify(getSnapshot(self)));
    },

    // 从sessionStorage恢复
    restoreFromSessionStorage: () => {
      try {
        const dialogStoreData = JSON.parse(sessionStorage.getItem('dialogStore') as string);
        if (dialogStoreData) {
          applySnapshot(self, dialogStoreData);
        }
      } catch (error) {
        console.log('CmsDialogStore:', error);
      }
    },

    // 清除sessionStorage中的缓存
    clearFromSessionStorage: () => {
      sessionStorage.removeItem('dialogStore');
    },
  }));
